import React, { useState } from 'react'
import {BsChevronCompactLeft, BsChevronCompactRight} from 'react-icons/bs'

export default function Modal({ openModal, setOpenModal, work }) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const images = work && work.images;
  const prevSlide = ()=>{
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex)
  }
  const nextSlide = ()=>{
    const isLastSlide = currentIndex === images.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex)
  }
  
    return (
      <>
      {openModal ? (
        <>
          <div
            className="justify-center items-center h-screen flex overflow-x-hidden  overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
          >
            <div className="relative w-full my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg max-h-[800px] shadow-lg relative flex flex-col w-full bg-[#0a192f] outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-pink-600 rounded-t">
                  <h3 className="text-4xl font-bold uppercase">
                  {work.title}
                  </h3>
                </div>
                {/*body*/}
                <div className="max-w-[1400px] h-[500px] m-auto w-full relative p-6 group">
                  <div style={{ backgroundImage: `url(${images[currentIndex]})` }} className='w-full h-full rounded-2xl my-4 bg-contain bg-center bg-no-repeat duration-500'></div>
                  {/* left arrow */}
                    <div className='hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer'>
                      <BsChevronCompactLeft onClick={prevSlide} size={30} />
                    </div>
                  {/* right arrow */}
                    <div className='hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 text-white cursor-pointer'>
                      <BsChevronCompactRight onClick={nextSlide} size={30}/>
                    </div>
                </div>
                <div className='p-5 leading-7 h-[160px] overflow-y-auto'>
                  <p>{work.description}</p>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-pink-600 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setOpenModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
      </>
  )
}
